import { UpdateUserPricingPlanAction } from "actions/user-pricing-plan";
import { User } from "features/user";
import { hasTeamwork } from "utils/feature-gates";

export const updateUserPricingPlanReducer = (
  state: User,
  action: UpdateUserPricingPlanAction
): User => {
  const nextUser: User = {
    ...state,
    plan: action.payload.plan,
    subscription: action.payload.subscription,
  };
  return {
    ...nextUser,
    // Entitlement-driven (teamwork): reverse-trial + teamwork entitlement,
    // plan-code only as guarded legacy fallback. Keep any already-true flag so a
    // mid-session plan change never revokes collaboration the user already had.
    isCollaborationEnabled:
      state.isCollaborationEnabled || hasTeamwork(nextUser),
  };
};
